import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ProvidersServices } from '../../services';
import { ProviderOrderViewPage } from '../provider-order-view/provider-order-view';
import { ProviderOrderCartPage } from '../provider-order-cart/provider-order-cart';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the ProviderOrderListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-provider-order-list',
    templateUrl: 'provider-order-list.html',
})
export class ProviderOrderListPage {
    provider_orders: any;
    searchbar_text: string = '';
    date_first: any;
    date_last: any;
    //datatable
    sorts = [
        { prop: 'created_at', dir: 'asc' },
        { prop: 'provider_static', dir: 'asc' },
        { prop: 'provider_email', dir: 'asc' },
        { prop: 'state', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        private providersServices: ProvidersServices,
        public translate: TranslateService,
        public toastCtrl: ToastController,
        public modalCtrl: ModalController) {

        this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - List', this.globals.restaurant.email, 'View', 'List provider orders', 'ProviderOrders', '');
    }

    /**********************************************************/
    /*                          INIT                          */
    /**********************************************************/

    ionViewWillEnter() {
        //init dates
        this.date_first = moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss');
        this.date_last = moment().endOf('month').format('YYYY-MM-DDTHH:mm:ss');
        
        
        //get
        this.providersServices.getPagesOrdersSuppliers(false, this.globals.replaceChar(this.date_first, 'T'), this.globals.replaceChar(this.date_last, 'T'), this.globals.user_uid);
    }

    /**********************************************************/
    /*                        FUNCIONES                       */
    /**********************************************************/

    //funcion que abre el modal para seleccionar fechas
    openSelectDatetimeModal() {
        let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
            title: this.translate.instant('stock-list-pedidos-proveedores'),
            date_first: this.date_first,
            date_last: this.date_last,
            cash_bool: false,
        });
        profileModal.onDidDismiss(data => {
            if (data) {
                this.date_first = data.date_first;
                this.date_last = data.date_last;
                //
                this.funcGetOrdersSuppliers();
            }
        });
        profileModal.present();
    }

    funcGetOrdersSuppliers() {
        if (this.date_first <= this.date_last) {
            this.providersServices.getPagesOrdersSuppliers(false, this.globals.replaceChar(this.date_first, 'T'), this.globals.replaceChar(this.date_last, 'T'), this.globals.user_uid);
        } else {
            //fechas mal lanzar toast
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-selecciona-rango-fechas-correcto'),
                duration: 3000,
                position: 'top'
            });
            toast.present();
        }
    }

    openCart() {
        this.navCtrl.push(ProviderOrderCartPage);
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.navCtrl.push(ProviderOrderViewPage, {
                provider_order: event.row
            });
        }
    }

    onSort(event) {
        var elements_array = this.providersServices.orders_suppliers_array_filtered;
        switch (event.column.name) {
            case 'created_at':
                elements_array.sort((a, b) => {
                    if (a.created_at && b.created_at) {
                        return event.newValue === 'asc' ? this.globals.timestampToDate(a.created_at).localeCompare(this.globals.timestampToDate(b.created_at)) : this.globals.timestampToDate(b.created_at).localeCompare(this.globals.timestampToDate(a.created_at));
                    } else {
                        return 0;
                    }
                });
                break;
            case 'provider_static':
                elements_array.sort((a, b) => {
                    if (a.provider_static && b.provider_static) {
                        return event.newValue === 'asc' ? a.provider_static.localeCompare(b.provider_static) : b.provider_static.localeCompare(a.provider_static);
                    } else {
                        return 0;
                    }
                });
                break;
            case 'provider_email':
                elements_array.sort((a, b) => {
                    if (a.provider_email && b.provider_email) {
                        return event.newValue === 'asc' ? a.provider_email.localeCompare(b.provider_email) : b.provider_email.localeCompare(a.provider_email);
                    } else {
                        return 0;
                    }
                });
                break;
            case 'state':
                elements_array.sort((a, b) => {
                    if (a.state && b.state) {
                        return event.newValue === 'asc' ? a.state.localeCompare(b.state) : b.state.localeCompare(a.state);
                    } else {
                        return 0;
                    }
                });
                break;
        }
        this.providersServices.orders_suppliers_array_filtered = elements_array;
    }
}



// WEBPACK FOOTER //
// ./src/pages/providers/orders/provider-order-list/provider-order-list.ts